module.exports = __webpack_public_path__ + "img/1D2A21_43443B_655B54_545C54-256px.571f090b.png";